export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden md:h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20illustration%2C%20montage%20of%20dynamic%20comic%20panels%20and%20colorful%20characters%20flying%20across%20a%20warm%20coral-orange%20dusk%20sky%2C%20bold%20outlines%2C%20flat%20cel%20shading%2C%20energetic%20composition%2C%20muted%20ink%20shadows%2C%20wide%20landscape%2C%20no%20text&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="漫画韩国下拉式韩漫阅读门户首屏背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />
      </div>

      <div className="relative z-10 flex w-full flex-col items-center px-4 text-center text-background-50 md:px-6">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-black/25 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100">
          <i className="ri-fire-fill text-primary-400" />
          汉化组每日更新 · 熟肉连载抢先看
        </span>
        <h1 className="max-w-4xl font-heading text-3xl leading-tight md:text-5xl">
          漫画韩国<span className="text-primary-400">下拉式</span>
          <span className="mt-1 block text-xl md:text-2xl text-background-100">一话到底，滚动追更不打断</span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          聚合多家汉化组熟肉更新，热门韩漫、最新连载、每日更新一网打尽。
          享受沉浸式的下拉式阅读体验，不错过任何一部好作品。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#hot"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即追更
          </a>
          <a
            href="#category"
            className="whitespace-nowrap rounded-md border border-background-100/40 bg-black/20 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-black/35"
          >
            浏览分类
          </a>
        </div>

        <div className="mt-10 flex items-center gap-6 text-background-100">
          {[
            ['1280+', '连载作品'],
            ['30+', '汉化组合作'],
            ['99%', '熟肉覆盖率'],
          ].map(([n, label]) => (
            <div key={label} className="text-center">
              <p className="font-heading text-xl md:text-2xl text-background-50">{n}</p>
              <p className="mt-1 text-xs text-background-200/80">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}